function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#027372"
    },
    points: "97.478,235.728 147.096,478.242 512,33.758 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#02ACAB"
    },
    points: "251.837,373.231 147.096,478.242 164.932,325.531 231.773,327.36 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#81E3E2"
    },
    points: "512,33.758 109.455,294.271 0,232.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#81E3E2"
    },
    points: "512,33.758 511.471,35.232 300.246,399.799 164.932,325.531  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#42C8C6"
    },
    points: "300.246,399.799 511.471,35.232 367.526,436.73 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.0b455460eaa006eaa0cde847b86ed83c.svg";
export { ForwardRef as ReactComponent };